var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slideup__wrapper"},[_c('div',{ref:"slideup",staticClass:"slideup"},[_c('div',{staticClass:"slideup__content"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }